import React, { useEffect, useState, useRef } from 'react';
import { _getCustomerListApi } from '../../services/Redux/Reducer/CustomerSlice';
import { useDispatch, useSelector } from 'react-redux';

export default function VisitorList(props) {

    const dispatch = useDispatch();
    const { fullVisitorList, isLoading } = useSelector((state) => state?.CustomerSlice);

    useEffect(() => {
        dispatch(_getCustomerListApi());
    }, []);

    const shuffleArray = (array) => {
        const copy = [...array];
        for (let i = copy.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [copy[i], copy[j]] = [copy[j], copy[i]];
        }
        return copy;
    };

    const [visitors, setVisitors] = useState([]);
    // const [loading, setLoading] = useState(true);

    const deduplicatedList = Array.from(new Map(fullVisitorList.map(item => [item.fullName, item])).values());
    useEffect(() => {
        // const timer = setTimeout(() => {
        const shuffled = shuffleArray(deduplicatedList);
        console.log("shuffledshuffled", shuffled)
        setVisitors(shuffled.slice(0, deduplicatedList?.length || 50));
        //     setLoading(false);
        // }, 4000);

        // return () => clearTimeout(timer);
    }, [fullVisitorList]);

    const scrollRef = useRef(null);
    let scrollInterval = useRef(null);
  
    useEffect(() => {
      const scrollElement = scrollRef.current;
  
      if (!scrollElement) return;
  
      // Clear existing interval
      if (scrollInterval.current) clearInterval(scrollInterval.current);
  
      const scrollStep = 1; // pixels
      const scrollDelay = 40; // ms
  
      scrollInterval.current = setInterval(() => {
        if (!scrollElement) return;
  
        // When reaching bottom, scroll back to top
        if (
          scrollElement.scrollTop + scrollElement.clientHeight >=
          scrollElement.scrollHeight
        ) {
          scrollElement.scrollTop = 0;
        } else {
          scrollElement.scrollTop += scrollStep;
        }
      }, scrollDelay);
  
      return () => {
        clearInterval(scrollInterval.current);
      };
    }, [visitors]);

    return (
        <>
            <div className='visitors-section'>
                <div class="bg-white shadow-md">
                    <div class="flex items-center justify-between bg-black text-white px-6 py-4">
                        <h2 class="text-lg font-normal font-osw">VISITORS TOURING THIS WEBSITE</h2>
                    </div>

                    <div class="lg:px-6 lg:py-4 p-[30px_15px] !pb-0">
                        {/* <div class="flex items-center space-x-2 mb-4">
                            <div class="flex space-x-1">
                                <span class="h-2 w-2 bg-yellow-500 rounded-full"></span>
                                <span class="h-2 w-2 bg-yellow-500 rounded-full"></span>
                                <span class="h-2 w-2 bg-yellow-500 rounded-full"></span>
                            </div>
                            <p class="text-gray-600 text-sm">Visitors Currently Enrolling</p>
                        </div> */}

                     <div className="space-y-4 flex justify-center items-center">
                        {isLoading ? (
                            <div className="animate-spin relative top-[-30px] rounded-full h-16 w-16 border-t-4 border-sky-700 border-solid mt-10"></div>
                        ) : (
                            <div ref={scrollRef} className="w-full max-h-[220px] overflow-y-auto pr-2 visitor-scrolling-element" style={{ scrollBehavior: "auto",WebkitOverflowScrolling: "touch" }}>
                            {visitors?.map((val, index) => (
                                <div key={index} className="flex items-center border mb-[20px]">
                                <div className="bg-black text-yellow-500 p-2 min-h-[50px] flex justify-center items-center">
                                    <svg
                                    className="h-6 w-6"
                                    fill="none"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    viewBox="0 0 24 24"
                                    xmlns="http://www.w3.org/2000/svg"
                                    >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M5.121 17.804A13.937 13.937 0 0112 15c2.5 0 4.847.655 6.879 1.804M15 11a3 3 0 11-6 0 3 3 0 016 0z"
                                    ></path>
                                    </svg>
                                </div>
                                <div className="ml-4 py-[5px]">
                                    <p className="text-sm font-bold">NEW VISITOR</p>
                                    <p className="text-sm text-gray-600">{`${val.firstName} ${val.lastName?.charAt(0).toUpperCase()} from ${val.countryCode}`}</p>
                                </div>
                                </div>
                            ))}
                            </div>
                        )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
